import { Link } from 'react-router-dom';
import { Card } from '../ui/Card';

export function NotFoundRoute() {
  return (
    <Card title="Not found">
      <p className="text-sm">
        That route does not exist yet. <Link className="text-copper-600 underline" to="/capture">Back to capture</Link>.
      </p>
    </Card>
  );
}
